import React, { useState } from "react";
import styled from "@emotion/styled";

const ProfileDropdown = ({
  name,
  imageUrl,
  menuItems = [
    { label: "Profile Settings", onClick: () => {} },
    { label: "Signout", onClick: () => {} },
  ],
  className,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <DropdownContainer className={className}>
      <Button onClick={toggleDropdown} isOpen={isOpen}>
        <Image>
          <ProfileImage style={{ backgroundImage: `url(${imageUrl})` }} />
        </Image>
        <UserName>{name}</UserName>
        {isOpen ? (
          <ChevronIcon viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.41 15.41L12 10.83L16.59 15.41L18 14L12 8L6 14L7.41 15.41Z"
              fill="currentColor"
            />
          </ChevronIcon>
        ) : (
          <ChevronIcon viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.41 8.59L12 13.17L16.59 8.59L18 10L12 16L6 10L7.41 8.59Z"
              fill="currentColor"
            />
          </ChevronIcon>
        )}
      </Button>
      {isOpen && (
        <ListMenu>
          {menuItems.map((item, index) => (
            <ListMenuItem key={index}>
              <MenuItemButton onClick={item.onClick}>
                <MenuItemText>{item.label}</MenuItemText>
              </MenuItemButton>
            </ListMenuItem>
          ))}
        </ListMenu>
      )}
    </DropdownContainer>
  );
};

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const Button = styled.button`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  border-radius: 999px;
  background: ${(props) =>
    props.isOpen ? "rgb(226, 232, 240)" : "rgb(241, 245, 249)"};
  padding: 4px 16px 4px 4px;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: rgb(226, 232, 240);
  }
`;

const Image = styled.div`
  width: 40px;
  height: 40px;
  position: relative;
`;

const ProfileImage = styled.div`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 40px;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
`;

const UserName = styled.span`
  color: rgb(33, 37, 67);
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 110%;
`;

const ChevronIcon = styled.svg`
  width: 24px;
  height: 24px;
  color: rgb(100, 116, 139);
`;

const ListMenu = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  display: flex;
  flex-direction: column;
  min-width: 218px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  background: rgb(255, 255, 255);
  padding: 8px;
  z-index: 1000;
`;

const ListMenuItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
`;

const MenuItemButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  padding: 12px 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  width: 100%;
  transition: background-color 0.2s ease;

  &:hover {
    background: rgb(241, 245, 249);
  }
`;

const MenuItemText = styled.span`
  color: rgb(33, 37, 67);
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 22px;
  text-align: left;
`;

export default ProfileDropdown;
